// removed by extract-text-webpack-plugin
module.exports = {"globalMainColor":"#28c2fb","successColor":"#4cb455","errorColor":"#f55","normalColor":"#e6ebf1","warningColor":"#ffa43b","infoColor":"#2db7f5","borderColor":"#ebeaf0","textColor":"#4b4b4b","labelColor":"#909090","labelBorder":"#d5d8dd"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalStyle.scss
// module id = XIaG
// module chunks = 29